import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DownloadService } from '../../../core/services/download/download.service';
import { PatchDownload } from '../../../core/models/download/patch-download.model';
import { Pageable } from '../../../core/models/common/pageable.model';

@Component({
  selector: 'app-patches',
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule
  ],
  templateUrl: './download-patches.component.html',
  styleUrl: './download-patches.component.scss'
})
export class DownloadPatchesComponent implements OnInit {
  patches: PatchDownload[] = [];
  pageInfo: Pageable<PatchDownload> | null = null;
  loading: boolean = false;
  error: string | null = null;
  currentPage: number = 0;
  itemsPerPage: number = 25;
  visiblePages: number[] = [];

  constructor(private readonly downloadService: DownloadService) {}

  ngOnInit(): void {
    this.loadPatches(this.currentPage, this.itemsPerPage);
  }

  loadPatches(page: number = 0, ipp: number = 25): void {
    this.loading = true;
    this.error = null;

    this.downloadService.getPatches(page, ipp)
      .subscribe({
        next: (response) => {
          this.pageInfo = response;
          this.patches = response.content;
          this.currentPage = page;
          this.updateVisiblePages();
          this.loading = false;
        },
        error: (err) => {
          console.error('Error loading patches', err);
          this.error = 'Error loading patches. Please try again later.';
          this.loading = false;
        }
      });
  }

  updateVisiblePages(): void {
    const totalPages = this.pageInfo?.page.totalPages || 0;
    const minPage = Math.max(this.currentPage - 2, 0);
    const maxPage = Math.min(this.currentPage + 2, totalPages - 1);
    this.visiblePages = [];

    for (let i = minPage; i <= maxPage; i++) {
      this.visiblePages.push(i);
    }
  }

  changePage(page: number, event: Event): void {
    event.preventDefault();
    if (page < 0 || page >= (this.pageInfo?.page.totalPages || 1)) {
      return;
    }
    this.loadPatches(page, this.itemsPerPage);
  }

  /**
   * Gets the list of provider names from a patch's files object
   * @param patch The patch to get providers for
   * @returns An array of provider names
   */
  getProviders(patch: PatchDownload): string[] {
    if (!patch || !patch.files) {
      return [];
    }
    return Object.keys(patch.files);
  }
}
